'use client';

import { c as _c } from "react/compiler-runtime";
import { Avatar, Button, Modal, Popover } from '@common/components';
import { SvgKebab } from '@common/icon';
import { cn } from '@core/utils';
import { useState } from 'react';
import { LoadingPageTemplate } from '@/components/client';
import { CommentForm } from './CommentForm';
interface CommentProps {
  profileUrl: string;
  nickname: string;
  daysAgo: string;
  mineYN: boolean;
  donationAmount?: number;
  comment: string;
  commentId: number;
  loading?: boolean;
  onUpdate?: (comment: string, commentId: number) => void;
  onDelete?: (commentId: number) => void;
}
export const Comment = t0 => {
  const $ = _c(56);
  const {
    profileUrl,
    nickname,
    daysAgo,
    mineYN,
    donationAmount,
    comment,
    commentId,
    onUpdate,
    onDelete,
    loading
  } = t0;
  const [isEdit, setIsEdit] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setIsEdit(true);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const handleUpdate = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setIsDeleteModalOpen(true);
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const handleDelete = t2;
  let t3;
  if ($[2] !== loading) {
    t3 = cn("flex flex-col", {
      "pointer-events-none": loading
    });
    $[2] = loading;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== profileUrl) {
    t4 = <Avatar alt={"\uC751\uC6D0\uC790 \uD504\uB85C\uD544 \uC774\uBBF8\uC9C0"} src={profileUrl} />;
    $[4] = profileUrl;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== nickname) {
    t5 = <p className="font-500 text-Gray-800 typo-body4">{nickname}</p>;
    $[6] = nickname;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== daysAgo || $[9] !== isEdit) {
    t6 = !isEdit && <p className="font-400 text-Gray-600 typo-caption1">{daysAgo}</p>;
    $[8] = daysAgo;
    $[9] = isEdit;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t5 || $[12] !== t6) {
    t7 = <div className="flex items-center gap-8">{t5}{t6}</div>;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== isEdit || $[15] !== mineYN) {
    t8 = !isEdit && mineYN && <Popover.Root floatingPadding={8} placement="bottom-end"><Popover.Trigger className="w-fit"><SvgKebab className="size-14 text-Gray-700" /></Popover.Trigger><Popover.Content className="flex flex-col px-0 py-12 font-400 text-Gray-900 typo-body3"><button type="button" className="w-118 px-16 py-8 text-left hover:bg-Gray-25" onMouseDown={handleUpdate}>수정</button><button type="button" className="w-118 px-16 py-8 text-left hover:bg-Gray-25" onMouseDown={handleDelete}>삭제</button></Popover.Content></Popover.Root>;
    $[14] = isEdit;
    $[15] = mineYN;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t7 || $[18] !== t8) {
    t9 = <div className="flex items-center justify-between">{t7}{t8}</div>;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== donationAmount || $[21] !== isEdit) {
    t10 = !isEdit && donationAmount && <p className="font-700 text-Gray-900 typo-body4">{donationAmount?.toLocaleString()}원 참여</p>;
    $[20] = donationAmount;
    $[21] = isEdit;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== comment || $[24] !== isEdit) {
    t11 = !isEdit && <p className="whitespace-pre-line pt-8 font-400 text-Gray-800 typo-body4">{comment}</p>;
    $[23] = comment;
    $[24] = isEdit;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== t10 || $[27] !== t11 || $[28] !== t9) {
    t12 = <div className="flex flex-1 flex-col">{t9}{t10}{t11}</div>;
    $[26] = t10;
    $[27] = t11;
    $[28] = t9;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== t12 || $[31] !== t4) {
    t13 = <div className="flex gap-10 py-12">{t4}{t12}</div>;
    $[30] = t12;
    $[31] = t4;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  let t14;
  if ($[33] !== comment || $[34] !== commentId || $[35] !== isEdit || $[36] !== onUpdate) {
    t14 = isEdit ? <CommentForm onClose={() => setIsEdit(false)} initialComment={comment} isEdit={true} onSubmit={comment_0 => {
      onUpdate?.(comment_0, commentId);
      setIsEdit(false);
    }} /> : <></>;
    $[33] = comment;
    $[34] = commentId;
    $[35] = isEdit;
    $[36] = onUpdate;
    $[37] = t14;
  } else {
    t14 = $[37];
  }
  let t15;
  if ($[38] !== loading) {
    t15 = loading ? <LoadingPageTemplate blur={true} fadeIn={true} /> : null;
    $[38] = loading;
    $[39] = t15;
  } else {
    t15 = $[39];
  }
  let t16;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = () => setIsDeleteModalOpen(false);
    $[40] = t16;
  } else {
    t16 = $[40];
  }
  let t17;
  let t18;
  if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <p className="pb-8 font-700 text-Gray-900 typo-body2">확인</p>;
    t18 = <p className="pb-24 font-400 text-Gray-700 typo-body3">응원 댓글을 삭제하시겠어요?</p>;
    $[41] = t17;
    $[42] = t18;
  } else {
    t17 = $[41];
    t18 = $[42];
  }
  let t19;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <Button theme="sub-fill" dimensions="H48" onClick={() => setIsDeleteModalOpen(false)} className="flex-1">취소</Button>;
    $[43] = t19;
  } else {
    t19 = $[43];
  }
  let t20;
  if ($[44] !== commentId || $[45] !== onDelete) {
    t20 = <div className="flex flex-col items-center px-20 pb-24 pt-32">{t17}{t18}<div className="flex w-full items-center gap-8">{t19}<Button dimensions="H48" onClick={() => {
          onDelete?.(commentId);
          setIsDeleteModalOpen(false);
        }} className="flex-1">삭제</Button></div></div>;
    $[44] = commentId;
    $[45] = onDelete;
    $[46] = t20;
  } else {
    t20 = $[46];
  }
  let t21;
  if ($[47] !== isDeleteModalOpen || $[48] !== t20) {
    t21 = <Modal opened={isDeleteModalOpen} onClose={t16} className="relative mt-0 w-280 min-w-[unset] overflow-hidden !p-0 lg:mt-0 lg:min-w-[unset]">{t20}</Modal>;
    $[47] = isDeleteModalOpen;
    $[48] = t20;
    $[49] = t21;
  } else {
    t21 = $[49];
  }
  let t22;
  if ($[50] !== t13 || $[51] !== t14 || $[52] !== t15 || $[53] !== t21 || $[54] !== t3) {
    t22 = <article className={t3}>{t13}{t14}{t15}{t21}</article>;
    $[50] = t13;
    $[51] = t14;
    $[52] = t15;
    $[53] = t21;
    $[54] = t3;
    $[55] = t22;
  } else {
    t22 = $[55];
  }
  return t22;
};